const COLOMBIA_OFFSET_MS = 5 * 60 * 60 * 1000; // UTC-5: Colombia está 5 horas detrás de UTC

/**
 * Convierte un Date UTC a string "YYYY-MM-DDTHH:mm" en hora Colombia.
 * Úsalo para el value de inputs type="datetime-local".
 */
export const toColombiaDatetimeLocal = (date) => {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d)) return '';
  return new Date(d.getTime() - COLOMBIA_OFFSET_MS).toISOString().slice(0, 16);
};

/**
 * Convierte un Date UTC a string "YYYY-MM-DD" en hora Colombia.
 * Úsalo para el value de inputs type="date".
 */
export const toColombiaDateOnly = (date) => {
  if (!date) return '';
  const d = new Date(date);
  if (isNaN(d)) return '';
  return new Date(d.getTime() - COLOMBIA_OFFSET_MS).toISOString().slice(0, 10);
};

/**
 * Devuelve el string "YYYY-MM-DD" del día de hoy en hora Colombia.
 * Úsalo para el atributo min de inputs type="date" o type="datetime-local".
 */
export const todayColombia = () => {
  return new Date(Date.now() - COLOMBIA_OFFSET_MS).toISOString().slice(0, 10);
};

/**
 * Devuelve el string "DD/MM/YYYY" en hora Colombia para mostrar fechas en
 * tablas, PDFs y UI legible (formato local es-CO). Si la entrada es inválida,
 * devuelve "—".
 *
 * Útil cuando el dato persistido es ISO en UTC (típico en MongoDB) pero la
 * UI vive en zona horaria America/Bogotá (UTC-5).
 */
export const formatoFechaColombia = (date) => {
  if (!date) return '—';
  const iso = toColombiaDateOnly(date);
  if (!iso) return '—';
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
};
